function high(el, binding) {
  const content = binding.value.content
    .replace(/<[^>]+>/gi, '')
    .replace(/<em>/gi, '')
    .replace(/<\/em>/gi, '');
  const reg = new RegExp(
    '(' + binding.value.key.split('').join('|') + ')',
    'gi'
  );
  el.innerHTML = content.replace(reg, '<em>$1</em>');
}

export default {
  bind(el, binding) {
    high(el, binding)
  },
  update(el, binding) {
    high(el, binding)
  }
}